import React from "react";
import { Box, Button, Divider, List, ListItem, ListItemText, Typography } from "@mui/material";

export const ResultsPanel = ({ resultados, onDownload }) => {
  return (
    <Box
      data-testid="results-panel"
      sx={{
        backgroundColor: "#FFFBE7",
        borderRadius: "8px",
        marginTop: "1.5rem",
        padding: "1rem"
      }}
    >
      <Typography
        variant="h6"
        sx={{ fontWeight: "bold", color: "#333", marginBottom: 2 }}
      >
        Resultados del análisis
      </Typography>

      <List data-testid="results-list">
        {resultados.map((req) => (
          <React.Fragment key={req.numero}>
            <ListItem data-testid="result-item" alignItems="flex-start">
              <ListItemText
                primary={
                  <>
                    <strong>Requerimiento N° {req.numero}: </strong>
                    {req.descripcion && (
                      <em style={{ marginLeft: "0.5rem" }}>{req.descripcion}</em>
                    )}
                  </>
                }
                secondary={
                  <div style={{ marginTop: "0.5rem" }}>
                    <p>
                      <strong>
                        Palabras y expresiones que violan reglas de no ambigüedad, singularidad, concisión, precisión o realismo:
                      </strong>{" "}
                      {req.stopWords || "-"}
                    </p>
                    <p>
                      <strong>Errores de estructura sintáctica o mal uso del lenguaje:</strong>{" "}
                      {req.syntaxErrors || "-"}
                    </p>
                    <p>
                      <strong>Posibles errores de ortografía:</strong>{" "}
                      {req.spellingErrors || "-"}
                    </p>
                    <p>
                      <strong>Recomendaciones para mejorar la escritura del requerimiento:</strong>
                      <span
                        style={{
                          display: "block",
                          marginLeft: "1rem",
                          whiteSpace: "pre-wrap"
                        }}
                      >
                        {req.recommendations || "-"}
                      </span>
                    </p>
                  </div>
                }
              />
            </ListItem>
            <Divider component="li" />
          </React.Fragment>
        ))}
      </List>

      <Box sx={{ textAlign: "center", marginTop: 2 }}>
        <Button
          data-testid="btn-download"
          variant="outlined"
          sx={{
            borderColor: "#FB8C00",
            color: "#FB8C00",
            "&:hover": {
              borderColor: "#F57C00",
              color: "#F57C00"
            }
          }}
          onClick={onDownload}
        >
          Descargar informe
        </Button>
      </Box>
    </Box>
  );
};
